import { useMemo } from "react";
import { parseAsString, useQueryState } from "nuqs";

import { filterConstructorServices, MOCK_CONSTRUCTOR_SERVICES } from "../constructor-services-page.lib";
import { ServiceCard } from "./service-card";

const searchParser = parseAsString.withDefault("").withOptions({ clearOnDefault: true });

/** Список карточек услуг с фильтрацией по поиску из URL. */
export const ConstructorServicesList = () => {
  const [search] = useQueryState("search", searchParser);
  const services = useMemo(() => filterConstructorServices(MOCK_CONSTRUCTOR_SERVICES, search ?? ""), [search]);

  return services.length > 0 ? (
    <ul data-testid="eacd-constructor-services-list" className="flex flex-col gap-4">
      {services.map((service) => (
        <ServiceCard key={service.id} service={service} />
      ))}
    </ul>
  ) : (
    <p className="paragraph-base text-type-minor py-8 text-center">Ничего не найдено</p>
  );
};
